<template>
  <svg
    id="Layer_2"
    width="26px"
    height="26px"
    viewBox="0 0 120 120"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <title>NUTRITION</title>
    <path
      d="M55.16,91.146a7.935,7.935,0,0,0,6.3,3.136A7.826,7.826,0,0,0,64,93.862a7.826,7.826,0,0,0,2.541.421,7.935,7.935,0,0,0,6.3-3.136l7.727-10.229A21.562,21.562,0,0,0,84.9,68,13.089,13.089,0,0,0,65.75,56.4V54.162h1.57a8.705,8.705,0,0,0,8.7-8.7,1.75,1.75,0,0,0-1.75-1.75h-3.32A8.682,8.682,0,0,0,63.9,47.336a9.076,9.076,0,0,0-7.245-3.619,1.75,1.75,0,0,0,0,3.5,5.6,5.6,0,0,1,5.595,5.595V56.4A13.089,13.089,0,0,0,43.1,68a21.562,21.562,0,0,0,4.331,12.919Zm15.785-43.93h1.267a5.2,5.2,0,0,1-4.892,3.445H66.054A5.2,5.2,0,0,1,70.945,47.217ZM56.189,58.411a9.543,9.543,0,0,1,6.6,2.642,1.778,1.778,0,0,0,2.412,0A9.584,9.584,0,0,1,81.4,68a18.043,18.043,0,0,1-3.624,10.81L70.047,89.037a4.479,4.479,0,0,1-5.322,1.351,1.748,1.748,0,0,0-1.449,0,4.478,4.478,0,0,1-5.322-1.351L50.227,78.808A18.043,18.043,0,0,1,46.6,68,9.6,9.6,0,0,1,56.189,58.411Z"
    />
    <path
      d="M102.667,10l-24.3.007-2.688-8.77A1.749,1.749,0,0,0,74.008,0H53.992a1.749,1.749,0,0,0-1.673,1.237l-2.688,8.77L25.333,10a6.758,6.758,0,0,0-6.75,6.75v104.5a6.758,6.758,0,0,0,6.75,6.75h77.334a6.758,6.758,0,0,0,6.75-6.75V16.75A6.758,6.758,0,0,0,102.667,10ZM95.916,23.5v91H32.084v-91ZM50.924,13.508h0A1.749,1.749,0,0,0,52.6,12.271L55.286,3.5H72.714L75.4,12.271a1.749,1.749,0,0,0,1.673,1.237h0l8.257-.006V20H42.667V13.5ZM105.917,121.25a3.254,3.254,0,0,1-3.25,3.25H25.333a3.254,3.254,0,0,1-3.25-3.25V16.75a3.254,3.254,0,0,1,3.25-3.25H39.167V20H30.334a1.75,1.75,0,0,0-1.75,1.75v94.5a1.75,1.75,0,0,0,1.75,1.75H97.666a1.75,1.75,0,0,0,1.75-1.75V21.75A1.75,1.75,0,0,0,97.666,20H88.833V13.5h13.834a3.254,3.254,0,0,1,3.25,3.25Z"
    />
    <path
      d="M61.312,13.5h5.375a1.75,1.75,0,0,0,0-3.5H61.312a1.75,1.75,0,0,0,0,3.5Z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "PrescricaoDieta",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
